var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"variant":_vm.statusColors[_vm.device.device_status_text]}},[_vm._v(" "+_vm._s(_vm.device.device_status_text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }